import {Button, Modal} from "react-bootstrap";
import greenCircle from "../../Images/green-circle.png";
import redCircle from "../../Images/red-circle.png";
import greyCircle from "../../Images/grey-circle.png";
import CustomIcon from "../../Components/CustomIcon/CustomIcon";
import React from "react";

export default function StatusLegendModal(props) {

    return (
        <Modal className={'SettingModal'} dialogClassName={'modal-settings'} show={props.show} backdrop={true} onHide={() => props.setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Status Legend</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <table style={{marginRight: "auto", marginLeft: "auto"}}>
                    <tr>
                        <th style={{width: '20%', paddingRight: '20px'}}>Status</th>
                        <th>Description</th>
                    </tr>
                    <tr>
                        <td style={{display: "flex", alignItems: 'center', alignContent: 'center'}}>
                            <CustomIcon
                            className={'mb-1 mt-1'}
                            width={26}
                            height={26}
                            src={greenCircle}
                            alt={"greenCircle"}
                        />
                        </td>
                        <td>Connected</td>
                    </tr>
                    <tr>
                        <td style={{display: "flex", alignItems: 'center', alignContent: 'center'}}>
                            <CustomIcon
                                className={' mb-1'}
                                width={26}
                                height={26}
                                src={redCircle}
                                alt={"redCircle"}/>
                        </td>
                        <td>Disconnected</td>
                    </tr>
                    <tr>
                        <td style={{display: "flex", alignItems: 'center', alignContent: 'center'}}>
                            <CustomIcon
                                className={'mb-1'}
                                width={26}
                                height={26}
                                src={greyCircle}
                                alt={"greyCircle"}
                            />
                        </td>
                        <td>Unknown</td>
                    </tr>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => props.setShow(false)}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}
